import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../lib/i18n";

type Item = {
  id: string;
  name: string;
  images?: string[];
  image?: string;
};

export default function VehicleList({
  items,
  routePrefix,
  titleKey,
  placeholderKey,
  imageClass = "h-56",
}: {
  items: Item[];
  routePrefix: string;
  titleKey?: string;
  placeholderKey?: string;
  imageClass?: string;
}) {
  const { t } = useTranslation();

  return (
    <div className="max-w-[1100px] mx-auto p-8">
      <h1 className="text-center tracking-widest text-[#1e3a8a]">{t(titleKey ?? "")}</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mt-4">
        {items.map((it) => {
          const src = it.image ?? (it.images && it.images[0]) ?? "";
          return (
            <Link key={it.id} to={`/${routePrefix}/${it.id}`} className="no-underline text-current">
              <div className="bg-white border border-gray-200">
                <img src={src} alt={it.name} className={`w-full ${imageClass} object-cover block`} />
                <div className="px-4 py-2 text-sm text-gray-700">{it.name}</div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
